import {inlineError} from '@s-ui/decorators/lib/index.js'
import {UseCase} from '@s-ui/domain'

import {UpdateSellerTradeDataRequestTransactionsValueObject} from '../ValueObjects/UpdateSellerTradeDataRequestTransactionsValueObject.js'

/**
 * @implements UseCase
 */
export class UpdateSellerTradeDataTransactionsUseCase extends UseCase {
  constructor({httpTransactionsRepository}) {
    super()
    this._httpTransactionsRepository = httpTransactionsRepository
  }

  @inlineError
  async execute({address, bankAccount, city, lastName, name, personalId, phone, tradeId, zipCode}) {
    const updateSellerTradeDataRequestTransactionsValueObject =
      UpdateSellerTradeDataRequestTransactionsValueObject.create({
        address,
        bankAccount,
        city,
        lastName,
        name,
        personalId,
        phone,
        tradeId,
        zipCode
      })

    const [error] = await this._httpTransactionsRepository.updateSellerTradeData(
      updateSellerTradeDataRequestTransactionsValueObject
    )

    if (error) return Promise.reject(error)
  }
}
